module.exports = __webpack_public_path__ + "stockLibrary/service_3-e88e84ba8a78b1e57f5fc458506e60d3.png";